export default {
  methods: {
    getDate(date) {
      const newDate = new Date(date);

      const day = newDate.getDate();
      const month = newDate.getMonth();
      const year = newDate.getFullYear();
      const hour = newDate.getHours();
      const minutes = newDate.getMinutes();

      return { day, month, year, hour, minutes };
    },

    prettyDate(date) {
      const newDate = this.getDate(date);

      const month = (newDate.month + 1).toString().padStart(2, '0');

      return `${newDate.day}/${month}/${newDate.year}`;
    },

    prettyFullDate(date) {
      const newDate = this.getDate(date);

      const month = (newDate.month + 1).toString().padStart(2, '0');

      return `${newDate.day}/${month}/${newDate.year} ${newDate.hour}:${newDate.minutes}`;
    },
  },
};
